import { render } from "./AssignIncentives.vue?vue&type=template&id=f761bea0"
import script from "./AssignIncentives.vue?vue&type=script&lang=js"
export * from "./AssignIncentives.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__